import { AdpEarningsField, AdpEarningsFieldConditions } from "@herbjoy/apex-api-models";
import { IComponentOptions, IOnChanges, IOnChangesObject, IFormController } from "angular";
import cloneDeep from "lodash/cloneDeep";
import { EventEmitter } from "../../../common/components/event-emitter";
import templateUrl from "./adp-earnings-field-editor.component.html";
import { payrollEntryNumericalFields } from "./payroll-fields";

export const AdpEarningsFieldEditorComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        earningsField: "<field",
        change: "&onChange"
    },
    controller: class AdpEarningsFieldEditorComponent implements IOnChanges {
        //@Input
        earningsField: AdpEarningsField;
        //@Input
        editForm: IFormController;
        change: EventEmitter<{ field: AdpEarningsField }>;
        departments = [
            { value: "Dept100", text: "100 Owner" },
            { value: "Dept200", text: "200 Admins" },
            { value: "Dept400", text: "400 Sales" },
            { value: "Dept900", text: "900 1099" },
        ];
        payrollEntryFields = payrollEntryNumericalFields.sort((a, b) => a < b ? -1 : 1);
        $onChanges(changesObj: IOnChangesObject): void {
            if (changesObj.field) {
                // Deep clone the input to avoid leaking changes to nested objects.
                this.earningsField = cloneDeep(this.earningsField);
            }
        }

        onAddCondition() {
            // Add an initialized condition.
            this.earningsField.conditions.push({
                departments: [],
                fieldsAboveZero: [],
                fieldsNotAboveZero: []
            });
        }

        onRemoveCondition(condition: AdpEarningsFieldConditions) {
            this.earningsField.conditions = this.earningsField.conditions.filter(p => p !== condition);
            this.onChangeField();
        }

        onChangeField() {
            if (this.validate()) {
                // Recall that the earnings field is a different reference from the original input.
                this.change({
                    $event: {
                        field: this.earningsField
                    }
                })
            }
        }

        onUnbindField() {
            this.earningsField.field = null;
            this.editForm.$setDirty();
            this.onChangeField();
        }

        onInitializeField() {
            this.earningsField = {
                conditions: []
            };
            this.onChangeField();
        }

        validate(): boolean {
            return this.editForm.$valid;
        }
    }
};
